<template>
    <div class="col-12">
      <div class="search-padd">
      <form @change="addEvent" v-on:submit.prevent>
        <div class="col-xs-12 override-padding">
          <div class="crm_admin_heading admin_heading_1 text-align-left">+/-</div>
          <div class="crm_admin_heading admin_heading_2 text-align-left">First Name</div>
          <div class="crm_admin_heading admin_heading_3 text-align-left">Last Name</div>
          <div :class="'crm_admin_heading ' + getEmailLabelClass + ' text-align-left'">Email</div>
          <div class="crm_admin_heading prospect_heading_5 text-align-center">Status</div>
          <div v-if="accountId > 0" class="crm_admin_heading admin_heading_4 text-align-center">Contact</div>
          <div v-if="accountId > 0" class="crm_admin_heading admin_heading_6 text-align-center">Preferences</div>
          <!-- <div class="crm_admin_heading admin_heading_6 text-align-center">Last Login</div>
          <div class="crm_admin_heading admin_heading_7 text-align-center"># of Login</div> -->
          <div class="crm_admin_heading admin_heading_8 text-align-left ">Title</div>
          <div class="crm_admin_heading admin_heading_23 text-align-center">News</div>
          <div class="crm_admin_heading admin_heading_9 text-align-center">{{ mentor_label_name }}</div>
          <div class="crm_admin_heading admin_heading_10 text-align-center">Billing</div>
          <div class="crm_admin_heading admin_heading_11 text-align-center">Primary</div>
          <div class="crm_admin_heading admin_heading_22 text-align-center">&nbsp;</div>
        </div>
        <div style="clear: both;"></div>
        <div v-show="loading" class="loading_show"><div class="spinner-border text-danger"></div></div>
        <div v-for="(admin_contact, index) in admin_contacts" v-if="loading === false">

          <div v-bind:class="'admin_details' + index" v-bind:id="'admin_details_more' + index">
            <div class="">
              <input
                  type="hidden"
                  v-bind:name="'uid[' + index + ']'"
                  v-bind:id="'uid_' + index"
                  v-model="admin_contact.uid">
              <div
                class="crm_admin_field_lists admin_heading_1 text-align-center font-25 line-height-30">
                <a v-b-toggle="'collapse_' + index" class="cursor-pointer">
                  <span class="when-opened">-</span> <span class="when-closed">+</span>
                </a>
              </div>
              <div class="crm_admin_field_lists admin_heading_2 text-align-left">
                <div class="search-padd">
                  <input
                      type="text"
                      v-bind:id="'admin_fname_' + index"
                      class="col-12 col-sm-12 ma-input-field"
                      ref="admin_fname"
                      v-bind:name="'admin_fname[' + index + ']'"
                      v-model="admin_contact.admin_fname"
                      v-validate="{ rules: { required: true, regex: nameRegex() } }"
                      placeholder="First Name"
                      maxlength="250"
                      autocomplete="off"
                      :disabled="researcherDisable === true"
                      @keydown.enter.prevent='enterSearchAction(index)'>
                  <div v-if="verrors.firstByRule('admin_fname[' + index + ']', 'required')" class="margin-bottom-5 validate-warning-msg">First name is required</div>
                  <div v-if="verrors.firstByRule('admin_fname[' + index + ']', 'regex')" class="margin-bottom-5 validate-warning-msg">First name should only contain - and _</div>
                </div>

                <div class="search-padd" id="mentee-group-wrapper" style="width: 215px;" v-if="(accountId > 0 && researcher == false)">
                  <multiselect v-model="admin_contact.admin_courses"
                  :options="admin_contact.applicable_courses" track-by="name" label="name"
                  placeholder="Courses" :multiple="true"  :close-on-select="false" :show-labels="false"
                  @input="captureMultiselectModificationAction(index, 'admin_courses', admin_contact.admin_courses)"
                  v-bind:name="'admin_courses[' + index + ']'"
                  v-bind:id="'admin_courses' + index"
                  :disabled="researcherDisable === true"
                  >
                  <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} selected</span></template>
                  </multiselect>
                  <div v-if="verrors.firstByRule('admin_courses[' + index + ']', 'required')" class="margin-bottom-5 validate-warning-msg">Course(s) is required</div>
                </div>
              </div>
              <div class="crm_admin_field_lists admin_heading_3 text-align-left">
                <div class="search-padd">
                  <input
                      type="text"
                      v-bind:id="'admin_lname_' + index"
                      class="col-12 col-sm-12 ma-input-field"
                      ref="admin_lname"
                      v-bind:name="'admin_lname[' + index + ']'"
                      v-model="admin_contact.admin_lname"
                      v-validate="{ rules: { required: true, regex: nameRegex() } }"
                      placeholder="Last Name"
                      maxlength="250"
                      autocomplete="off"
                      :disabled="researcherDisable === true"
                      @keydown.enter.prevent='enterSearchAction(index)'>
                  <div v-if="verrors.firstByRule('admin_lname[' + index + ']', 'required')" class="margin-bottom-5 validate-warning-msg">Last name is required</div>
                  <div v-if="verrors.firstByRule('admin_lname[' + index + ']', 'regex')" class="margin-bottom-5 validate-warning-msg">Last name should only contain - and _</div>
                </div>
              </div>
              <div :class="'crm_admin_field_lists ' + getEmailLabelClass + ' text-align-left'">
                <div class="search-padd">
                  <input
                      type="text"
                      v-bind:id="'admin_email_' + index"
                      class="col-12 col-sm-12 ma-input-field"
                      ref="admin_email"
                      v-bind:name="'admin_email[' + index + ']'"
                      v-model="admin_contact.admin_email"
                      v-validate="'required|email'"
                      placeholder="Email"
                      maxlength="250"
                      role="presentation"
                      autoComplete="none"
                      :disabled="researcherDisable === true"
                      @keydown.enter.prevent='enterSearchAction(index)'>
                  <div v-if="verrors.firstByRule('admin_email[' + index + ']', 'required')" class="margin-bottom-5 validate-warning-msg">Email is required</div>
                  <div v-if="verrors.firstByRule('admin_email[' + index + ']', 'email')" class="margin-bottom-5 validate-warning-msg">Email is invalid</div>
                  <div v-if="verrors.firstByRule('admin_email[' + index + ']', 'exists')" class="margin-bottom-5 validate-warning-msg">Email address already exists</div>
                </div>
                <div class="search-padd" id="mentee-group-wrapper" style="width: 195px;" v-if="(accountId > 0 && researcher == false)">
                  <multiselect v-model="admin_contact.admin_assessments"
                  :options="admin_contact.applicable_assessments" track-by="name" label="name"
                  placeholder="Assessments" :multiple="true"  :close-on-select="false" :show-labels="false"
                  @input="captureMultiselectModificationAction(index, 'admin_assessments', admin_contact.admin_assessments)"
                  v-bind:name="'admin_assessments[' + index + ']'"
                  v-bind:id="'admin_assessments' + index"
                  :disabled="researcherDisable === true"
                  >
                  <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} selected</span></template>
                  </multiselect>
                  <div v-if="verrors.firstByRule('admin_assessments[' + index + ']', 'required')" class="margin-bottom-5 validate-warning-msg">Assessment(s) is required</div>
                </div>
              </div>
              <div class="crm_admin_field_lists prospect_heading_5 text-align-center">
                <div class="search-padd">
                  <!-- <input
                      type="checkbox"
                      v-bind:id="'is_enabled_' + index"
                      v-bind:name="'is_enabled[' + index + ']'"
                      ref="is_enabled"
                      v-model="admin_contact.is_enabled"
                      :value="1"> -->

                  <b-form-select
                      v-if="admin_contact.admin_status == 'Pending'"
                      class="col-12 col-sm-12 ma-input-field"
                      v-bind:name="'admin_status[' + index + ']'"
                      v-bind:id="'admin_status_' + index"
                      v-model="admin_contact.admin_status"
                      :options="admin_status_pending_options" :disabled="( accountId > 0 && (researcher == true || admin_contact.disableStatus == true)) ? true : false">
                      </b-form-select>
                  <b-form-select
                      v-else
                      class="col-12 col-sm-12 ma-input-field"
                      v-bind:name="'admin_status[' + index + ']'"
                      v-bind:id="'admin_status_' + index"
                      v-model="admin_contact.admin_status"
                      :options="admin_status_options" :disabled="( accountId > 0 && (researcher == true || admin_contact.disableStatus == true)) ? true : false">
                      </b-form-select>
                </div>
              </div>
              <div v-if="accountId > 0" class="crm_admin_field_lists admin_heading_4 text-align-center crm_field_padding_top">
                <div class="search-padd">
                  <button class="btn btn-sm ma-blue-btn5" @click="openContactModal(index)" :disabled="(researcher == true) ? true : false">Contact</button>
                </div>
                <div v-if="admin_contact.is_manager" class="search-padd" style="width: 200px; margin-top: 6px;">
                  <div class="form-group row">
                    <div class="col-12 pr-0">
                    <input
                      type="checkbox"
                      v-bind:id="'manager_pathway_' + index"
                      ref="manager_pathway"
                      v-bind:name="'manager_pathway[' + index + ']'"
                      v-model="admin_contact.managerpathway"
                      :checked="admin_contact.managerpathway_checked"
                      :value="1" style="margin-top: 10px; display: inline-block;">
                    <label class="" for="manager_pathway" style="margin-top: -3px; margin-bottom: 0; display: inline-block; color: #002F42;">Enable Pathway Page</label>
                    </div>
                  </div>
                </div>

              </div>

              <div v-if="accountId > 0" class="crm_admin_field_lists admin_heading_6 text-align-center crm_field_padding_top">
                <div class="search-padd">
                  <button class="btn btn-sm ma-blue-btn5" @click="openUserPreferenceModal(index)" :disabled="(researcher == true) ? true : false">Preferences</button>
                </div>
              </div>              
              <!-- <div class="crm_admin_field_lists admin_heading_6 text-align-center crm_field_padding_top">
                <div class="search-padd">
                  {{ admin_contact.last_login }}
                </div>
              </div>
              <div class="crm_admin_field_lists admin_heading_7 text-align-center crm_field_padding_top">
                <div class="search-padd">
                  {{ admin_contact.no_login }}
                </div>
              </div> -->
              <div class="crm_admin_field_lists admin_heading_8 text-align-left">
                <div class="search-padd">
                  <!-- <input
                      type="text"
                      v-bind:id="'admin_title_' + index"
                      class="col-12 col-sm-12 ma-input-field"
                      ref="admin_title"
                      v-bind:name="'admin_title[' + index + ']'"
                      v-model="admin_contact.admin_title"
                      placeholder="Title"
                      maxlength="250"> -->
                  <b-form-select
                      class="col-12 col-sm-12 ma-input-field"
                      v-bind:name="'admin_title[' + index + ']'"
                      v-bind:id="'admin_title_' + index"
                      v-model="admin_contact.admin_title"
                      :options="titlesOptions">
                      </b-form-select>
                  
                </div>
                <div v-if="admin_contact.is_transfer_status == 1" class="search-padd" id="mentee-group-wrapper"  style="margin-top: 15px; width: auto; text-align: center;">
                  <button class="goal-indicator-btn greenBtn">Transferred</button>
                </div>
              </div>
              <div class="crm_admin_field_lists admin_heading_23 text-align-center crm_field_padding_top">
                <div class="search-padd">
                  <input
                      type="checkbox"
                      v-bind:id="'is_news_' + index"
                      ref="is_news"
                      v-bind:name="'is_news[' + index + ']'"
                      v-model="admin_contact.is_news" @click="changeUserNewsSubscribe(index, $event)"
                      :value="1" :disabled="researcherDisable === true">
                </div>
              </div>
              <div class="crm_admin_field_lists admin_heading_9 text-align-center crm_field_padding_top">
                <div class="search-padd">
                  <input
                      type="checkbox"
                      :disabled="researcherDisable == true ? true : false"
                      v-bind:id="'is_manager_' + index"
                      ref="is_manager"
                      v-bind:name="'is_manager[' + index + ']'"
                      v-model="admin_contact.is_manager"
                      @click="getAdminCourses($event, index)"
                      :value="1" >
                </div>
              </div>
              <div class="crm_admin_field_lists admin_heading_10 text-align-center crm_field_padding_top">
                <div class="search-padd">
                  <input
                      type="radio"
                      v-bind:id="'is_billing_' + index"
                      ref="is_billing"
                      v-bind:name="'is_billing[' + index + ']'"
                      v-model="admin_contact.is_billingadmin"
                      @click="clickBillingAdmin(index)"
                      :value="1" :disabled="researcherDisable === true">
                </div>
              </div>
              <div class="crm_admin_field_lists admin_heading_11 text-align-center crm_field_padding_top">
                <div class="search-padd">
                  <input
                      type="radio"
                      v-bind:id="'is_primaryadmin_' + index"
                      ref="is_primaryadmin"
                      v-bind:name="'is_primaryadmin[' + index + ']'"
                      v-model="admin_contact.is_primaryadmin"
                      @click="clickPrimaryAdmin(index)"
                      :value="1" :disabled="researcherDisable === true">
                </div>
              </div>
              <div class="crm_admin_field_lists admin_heading_22 text-align-center">
                <div
                  class="search-padd delete-icon" style=""
                  v-if="admin_contacts.length > 1">
                    <i class="fa fa-window-close cursor-pointer" aria-hidden="true" @click="removeAdmin(index)" :disabled="researcherDisable === true"></i>
                </div>
              </div>


            </div>
            <div style="clear: both;"></div>

            <b-collapse v-bind:id="'collapse_' + index" class="">

              <div class="col-md-6 float-left override-padding">
                <div class="col-12">
                  <input
                      type="text"
                      v-bind:name="'id_number[' + index + ']'"
                      v-bind:id="'id_number_' + index"
                      class="col-12 col-sm-12 ma-input-field"
                      v-model="admin_contact.id_number"
                      placeholder="ID Number"
                      maxlength="150" :disabled="researcherDisable === true">
                    <input
                      type="password"
                      v-bind:name="'newpassword[' + index + ']'"
                      v-bind:id="'newpassword_' + index"
                      class="col-12 col-sm-12 ma-input-field"
                      v-model="admin_contact.password"
                      placeholder="Password"
                      v-validate="'min:6'"
                      maxlength="20"
                      :disabled="(researcher == true) ? true : false"
                      role="presentation"
                      autoComplete="new-password"
                       >
                    <div v-show="verrors.has('newpassword[' + index + ']')" class="validate-warning-msg">The password field must be at least 6 characters</div>
                  <input
                      type="text"
                      v-bind:name="'mobile[' + index + ']'"
                      v-bind:id="'mobile_' + index"
                      class="col-md-12 ma-input-field"
                      v-model="admin_contact.mobile"
                      @keyup="adminMobileValid($event, index)"
                      @blur="adminMobileValid($event, index)"
                      v-validate="{ rules: { regex: adminPhoneRegex() } }"
                      placeholder="Mobile"
                      maxlength="14" :disabled="researcherDisable === true">
                  <div v-if="verrors.has('mobile[' + index + ']')" class="margin-bottom-5 validate-warning-msg">Phone number is invalid</div>
                  <div class="col-12 col-md-12 override-padding">
                    <div class="col-md-9 float-left padding-lr-5" style="padding-left: 0">
                      <input
                          type="text"
                          v-bind:name="'phone[' + index + ']'"
                          v-bind:id="'phone_' + index"
                          class="col-md-12 ma-input-field"
                          v-model="admin_contact.phone"
                          @keyup="adminPhoneValid($event, index)"
                          @blur="adminPhoneValid($event, index)"
                          v-validate="{ rules: { regex: adminPhoneRegex() } }"
                          placeholder="Phone"
                          maxlength="14" :disabled="researcherDisable === true">
                      <div v-if="verrors.has('phone[' + index + ']')" class="margin-bottom-5 validate-warning-msg">Phone number is invalid</div>
                    </div>
                    <div class="col-md-3 float-left override-padding">
                      <input
                          type="text"
                          v-bind:name="'phone_ext[' + index + ']'"
                          v-bind:id="'phone_ext_' + index"
                          class="col-md-12 ma-input-field"
                          v-model="admin_contact.phone_ext"
                          @keyup="adminPhoneExtValid($event, index)"
                          @blur="adminPhoneExtValid($event, index)"
                          placeholder="Ext"
                          maxlength="3" :disabled="researcherDisable === true">
                    </div>
                  </div>
                  <div style="clear: both;"></div>
                  <div class="col-12 col-md-12 override-padding" style="float: none;  padding-top: 7px !important;" v-if="admin_contact.eula">
                    <div class="col-md-12 p-0">
                      <label class="" for="submit_comment_1" style="color: #002F42;">EULA accepted on : {{ admin_contact.eula }}</label>
                    </div>
                  </div>


                </div>
              </div>
              <div class="col-md-6 float-left override-padding">
                <div class="col-12">
                  <input
                      type="text"
                      v-bind:name="'location_name[' + index + ']'"
                      v-bind:id="'location_name_' + index"
                      class="col-12 col-sm-12 ma-input-field"
                      v-model="admin_contact.location_name"
                      placeholder="Location Name"
                      maxlength="250" :disabled="researcherDisable === true">
                  <div class="col-12 col-md-12 override-padding">
                    <div class="col-md-10 float-left override-padding">
                      <b-form-select
                          class="col-12 col-sm-12 ma-input-field"
                          v-bind:name="'country[' + index + ']'"
                          v-bind:id="'country_' + index"
                          v-model="admin_contact.country"
                          :options="country_options"
                          v-on:change="getStateLists(admin_contact.country, index)" :disabled="researcherDisable === true">
                          </b-form-select>
                    </div>
                    <div class="col-md-2 float-left override-padding">
                      <button
                        v-on:click="updateCountryUS(index)"
                        class="col-12 btn btn-red edit-action-btn margin-bottom-5"
                         :disabled="researcherDisable === true">US</button>
                    </div>
                  </div>
                  <input
                      type="text"
                      v-bind:name="'address[' + index + ']'"
                      v-bind:id="'address_' + index"
                      class="col-12 col-sm-12 ma-input-field"
                      v-model="admin_contact.address"
                      placeholder="Billing Address 1"
                      maxlength="250" :disabled="researcherDisable === true">
                  <input
                      type="text"
                      v-bind:name="'address2[' + index + ']'"
                      v-bind:id="'address2_' + index"
                      class="col-12 col-sm-12 ma-input-field"
                      v-model="admin_contact.address2"
                      placeholder="Billing Address 2"
                      maxlength="250" :disabled="researcherDisable === true">

                  <input
                      type="text"
                      v-bind:name="'city[' + index + ']'"
                      v-bind:id="'city_' + index"
                      class="col-12 col-sm-12 ma-input-field"
                      v-model="admin_contact.city"
                      placeholder="Billing City"
                      maxlength="100" :disabled="researcherDisable === true">
                  <input
                      type="text"
                      v-bind:name="'zip[' + index + ']'"
                      v-bind:id="'zip_' + index"
                      class="col-12 col-sm-12 ma-input-field"
                      v-model="admin_contact.zip"
                      placeholder="Blling Zip"
                      v-validate="{ rules: { regex: adminPostalCodeRegex(index) } }"
                      maxlength="10" :disabled="researcherDisable === true">
                  <div v-if="verrors.firstByRule('zip[' + index + ']', 'regex')" class="margin-bottom-5 validate-warning-msg">Billing zip is invalid</div>
                  <b-form-select
                      class="col-12 col-sm-12 ma-input-field"
                      v-bind:name="'state[' + index + ']'"
                      v-bind:id="'state_' + index"
                      v-model="admin_contact.state"
                      :options="admin_contact.state_options" :disabled="researcherDisable === true">
                      </b-form-select>
                  <input
                      type="text"
                      v-bind:name="'market_area[' + index + ']'"
                      v-bind:id="'market_area_' + index"
                      class="col-12 col-sm-12 ma-input-field"
                      v-model="admin_contact.market_area"
                      placeholder="Billing Market Area"
                      maxlength="100" :disabled="researcherDisable === true">
                </div>
              </div>
              <div style="clear: both;"></div>

            </b-collapse>
          </div>
          <div style="clear: both;"></div>

          <!-- Courses start -->
          <div v-bind:class="'admin_details' + index" v-bind:id="'mentee_details_more' + index" v-if="(accountId > 0 && researcher == false)">
              <div
                class="course-title">
                <a v-b-toggle="'courses_collapse_' + index">
                Courses <span class="when-opened">-</span> <span class="when-closed">+</span>
                </a>
              </div>
              <b-collapse v-bind:id="'courses_collapse_' + index" @shown="getCoursesInfo(index)">
                <CourseUserResultsHeader
                  :ref="'course_user_results_header_' + index">
                </CourseUserResultsHeader>
            </b-collapse>
          </div>
          <!-- Courses end -->
          <div style="clear: both; margin-top: 10px;"></div>

        </div>

        <button
            v-on:click="addAdmin()"
            class="btn btn-red btn-group-sm input-height-15"
             :disabled="researcherDisable === true"><i class="fa fa-plus spacer-icon" aria-hidden="true"></i>New Admin</button>

        <div style="clear: both;" class="margin-bottom-10"></div>

        <DeleteModal :isModalVisible="isDeleteModalVisible" :id="delete_id" :parent_id="parent_id" @close="isDeleteModalVisible = false">
          <span v-if="loading" class="pull-right text-danger">
            Loading...
          </span>
          <div slot="header" class="sub-heading">Are you sure you want to delete?</div>
          <div slot="body">

          </div>
          <div slot="footer" class="col-3 override-padding">
            <button class="left col-12 btn btn-red" @click="isDeleteModalVisible = false; deleteAdminAction(delete_id)">Confirm</button>
          </div>
        </DeleteModal>

        <ValidationModal :isModalVisible="isInfoModalVisible" v-if="validationMessage" @close="isInfoModalVisible = false">
          <span class="pull-right text-danger">
            Loading...
          </span>
          <div slot="header" style="color: #002F42;" class="sub-heading pre-formatted">{{  validationMessage }}</div>
          <div slot="body">

          </div>
          <div slot="footer" class="col-3 override-padding">
          </div>
        </ValidationModal>

        <ContactModal 
          :isModalVisible="isContactModalVisible" 
          :id="delete_id" 
          :parent_id="parent_id" 
          @close="isContactModalVisible = false"
          ref="admin_contact_form">
        </ContactModal>


      </form>
      </div>
      <UserPreferenceModal 
        :isModalVisible="isUserPreferenceModalVisible" 
        @close="isUserPreferenceModalVisible = false"
        ref="user_preference">
      </UserPreferenceModal>


      <PreferenceUpdateConfirmModal :isModalVisible="isPrefereceUpdateConfirmModalVisible"  @close="closeConfirm()">
        <span v-if="loading" class="pull-right text-danger">
          Loading...
        </span>
        <div slot="header" class="sub-heading" style="margin-left: 0;">{{ modal_title }}</div>
        <div slot="body">
          <i><span v-html="modal_message"></span></i>
        </div>
        <div slot="footer" class="col-12 p-0">
          <div class="col-6 float-left p-0">
            <button class="btn btn-sm ma-white-btn1" @click="closeConfirm()">Cancel</button>
          </div>
          <div class="col-6 float-left p-0 text-align-right">
            <button class="btn btn-sm ma-blue-btn1" @click="onSubmit()">{{ buttonTitle }}</button>
          </div>
          <div style="clear: both;"></div>
        </div>
      </PreferenceUpdateConfirmModal>



      <SuccessConfirmModal :isModalVisible="isSuccessConfirmModalVisible"  @close="closeSuccessConfirm()">
        <span v-if="loading" class="pull-right text-danger">
          Loading...
        </span>
        <div slot="header" class="sub-heading" style="margin-left: 0;">{{ modal_success_title }}</div>
        <div slot="body">
          <i><span v-html="modal_success_message"></span></i>
        </div>
        <div slot="footer" class="col-12 p-0">
          <div class="col-12 text-center">
            <button class="btn btn-sm ma-blue-btn1" @click="closeSuccessConfirm()">Close</button>
          </div>
          <div style="clear: both;"></div>
        </div>
      </SuccessConfirmModal>




    </div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import axios from 'axios';
import VeeValidate from 'vee-validate';
import EventBus from '../../bus';
import DeleteModal from '../shared/delete_modal_alert.vue';
import { Validator } from "vee-validate";
import ValidationModal from '../shared/validation_modal_alert.vue';
import ContactModal from './admin_contact.vue';
import UserPreferenceModal from './account_lookup_user_preference_modal.vue';
import Multiselect from 'vue-multiselect';
import CourseUserResultsHeader from './course_user_results_header.vue';
import PreferenceUpdateConfirmModal from '../admin/preference_confirm_modal.vue';
import SuccessConfirmModal from '../admin/preference_confirm_modal.vue';


Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

const customTitlesOptions = [
  {value: '', text: 'Select Title'},
  {value: 'Agriculture Instructor', text: 'Agriculture Instructor'},
  {value: 'Associate Publisher', text: 'Associate Publisher'},
  {value: 'Automotive Collision Instructor', text: 'Automotive Collision Instructor'},
  {value: 'Automotive Instructor', text: 'Automotive Instructor'},
  {value: 'CEO', text: 'CEO'},
  {value: 'Collision Center Manager', text: 'Collision Center Manager'},
  {value: 'Content Director', text: 'Content Director'},
  {value: 'COO', text: 'COO'},
  {value: 'CTE Assistant Director', text: 'CTE Assistant Director'},  
  {value: 'CTE Coordinator', text: 'CTE Coordinator'},
  {value: 'CTE Director', text: 'CTE Director'},
  {value: 'Department Head, Agriculture', text: 'Department Head, Agriculture'},  
  {value: 'Department Head, Automotive Collision', text: 'Department Head, Automotive Collision'},
  {value: 'Department Head, Automotive Technology', text: 'Department Head, Automotive Technology'},
  {value: 'Department Head, Heavy Duty/Diesel', text: 'Department Head, Heavy Duty/Diesel'},
  {value: 'Department Head, Machining', text: 'Department Head, Machining'}, 
  {value: 'Department Head, Welding', text: 'Department Head, Welding'}, 
  {value: 'Director of Operations', text: 'Director of Operations'},
  {value: 'Editor', text: 'Editor'},
  {value: 'Editorial Director', text: 'Editorial Director'},
  {value: 'Executive Manager', text: 'Executive Manager'},
  {value: 'Fixed Operations Director', text: 'Fixed Operations Director'},
  {value: 'Fixed Operations Manager', text: 'Fixed Operations Manager'},
  {value: 'Front Office', text: 'Front Office'},
  {value: 'General Manager', text: 'General Manager'},
  {value: 'General Sales Manager', text: 'General Sales Manager'},
  {value: 'Group Publisher', text: 'Group Publisher'},
  {value: 'Heavy-Duty/Diesel Instructor', text: 'Heavy-Duty/Diesel Instructor'},
  {value: 'HR Director', text: 'HR Director'},
  {value: 'Machining Instructor', text: 'Machining Instructor'},
  {value: 'Managing Partner', text: 'Managing Partner'},
  {value: 'Owner/DP', text: 'Owner/DP'},
  {value: 'President', text: 'President'},
  {value: 'Program Director', text: 'Program Director'},
  {value: 'Service Advisor', text: 'Service Advisor'},
  {value: 'Service Manager', text: 'Service Manager'},
  {value: 'Service Operations Manager', text: 'Service Operations Manager'},
  {value: 'Store Manager', text: 'Store Manager'},
  {value: 'Technician', text: 'Technician'},
  {value: 'Vice President', text: 'Vice President'},
  {value: 'Welding Instructor', text: 'Welding Instructor'}, 
  {value: 'Prospect', text: 'Prospect'},
]

export default {
      props: ['accountId', 'accountStatus', 'researcherDisable'],
      data() {
        return {
          admin_contacts: [],
          country_options: [],
          isDeleteModalVisible: false,
          parent_id: '',
          delete_id: '',
          loading: false,
          remove_data: '',
          mentor_label_name: 'Manager',
          updated_admin_contacts: {},
          isInfoModalVisible: false,
          validationMessage: '',
          titlesOptions: customTitlesOptions,
          isContactModalVisible: false,
          isUserPreferenceModalVisible: false,
          admin_courses: [],
          courses_options: [],
          user_courses: [],
          courses_results: [],
          mentor_courses: [],
          mentor_assessments: [],
          admin_status_options: [
            { value: 'Active', text: 'Active' },
            { value: 'Inactive', text: 'Inactive' },
            { value: 'Prospect', text: 'Prospect' },
          ],
          admin_status_pending_options: [
            { value: 'Active', text: 'Active' },
            { value: 'Inactive', text: 'Inactive' },
            { value: 'Prospect', text: 'Prospect' },
            { value: 'Pending', text: 'Pending' }
          ],
          researcher: false,
          isPrefereceUpdateConfirmModalVisible: false,
          isSuccessConfirmModalVisible: false,
          buttonTitle: '',
          modal_title: '',
          modal_message: '',
          modal_success_title: '',
          modal_success_message: '',
          preference_modal_first_name: '',
          preference_modal_last_name: '',
          preference_modal_user_id: '',
          preference_news_subscription_selected: '',
          admin_index: '',
          admin_news_old_value: '',

        }
      },
      components: {
        DeleteModal,
        ValidationModal,
        ContactModal,
        Multiselect,
        CourseUserResultsHeader,
        UserPreferenceModal,
        PreferenceUpdateConfirmModal,
        SuccessConfirmModal,
      },
      computed: {
        getEmailLabelClass() {
          if (this.accountId > 0) {
            return 'prospect_admin_heading_12';
          } else {
            return 'prospect_email_heading_cls';
          }
        }
      },
      methods: {
        nameRegex: function() {
          return /^[a-zA-Z-_ ']*$/;
        },
        onSubmit() {
          axios('/account_lookup/news_subscription_update',
              {
              method: 'POST',
              data: {
                  isSubscribeNews: this.preference_news_subscription_selected,
                  account_id: this.accountId,
                  user_id: this.preference_modal_user_id,
              }
              },
          )
          .then(response => {
            if((this.preference_news_subscription_selected == true)) {
              this.modal_success_title = 'Mentoring Support Communication Updated';
              this.modal_success_message = 'Subscribed to mentoring news, updates, promotions & more!';
              this.isModalVisible = false;
              this.isPrefereceUpdateConfirmModalVisible = false;
              this.isSuccessConfirmModalVisible = true;
            }
            else if((this.preference_news_subscription_selected == false)) {
              this.modal_success_title = 'Mentoring Support Communication Updated';
              this.modal_success_message = 'Unsubscribed to mentoring news, updates, promotions & more!.';
              this.isModalVisible = false;
              this.isPrefereceUpdateConfirmModalVisible = false;
              this.isSuccessConfirmModalVisible = true;
            }

          })
          .catch(error => {

          })
        },          
        changeUserNewsSubscribe(index, event) {
          if(this.admin_contacts[index].uid > 0) {
            this.admin_news_old_value = this.admin_contacts[index].is_news;
            this.admin_index = index;
            this.preference_modal_first_name = this.admin_contacts[index].admin_fname;
            this.preference_modal_last_name = this.admin_contacts[index].admin_lname;
            this.preference_modal_user_id = this.admin_contacts[index].uid;
            if(event.target.checked == true) {
              this.buttonTitle = 'Subscribe';
              this.modal_title = 'Are you sure want to subscribe ' + this.preference_modal_first_name + ' ' + this.preference_modal_last_name + ' to news, updates and promotions & more!?';
              this.modal_message = '';
              this.preference_news_subscription_selected = true;
            }
            else {
              this.buttonTitle = 'Unsubscribe';
              this.modal_title = 'Are you sure want to unsubscribe ' + this.preference_modal_first_name + ' ' + this.preference_modal_last_name + ' to news, updates and promotions & more!?';
              this.modal_message = '<b>Note:</b> ' + this.preference_modal_first_name + ' ' + this.preference_modal_last_name + ' will still receive transactional & account-related support emails.';
              this.preference_news_subscription_selected = false;
            }
            this.isPrefereceUpdateConfirmModalVisible = true;
          }
        },
        closeSuccessConfirm() {
          this.isSuccessConfirmModalVisible = false;
          this.preference_news_subscription_selected = '';
          this.$emit('close');
          this.navigate();
        },
        closeConfirm() {
          this.isPrefereceUpdateConfirmModalVisible = false;
          this.admin_contacts[this.admin_index].is_news = this.admin_news_old_value;
          this.$emit('close');
        },
        addAdmin: function() {
          this.admin_contacts.push({
            uid: 0,
            admin_fname: '',
            admin_lname: '',
            admin_email: '',
            admin_title: '',
            is_enabled: 0,
            is_transfer_status: 0,
            is_manager: 0,
            is_news: 1,
            is_billingadmin: 0,
            is_primaryadmin: 0,
            id_number: '',
            password: '',
            mobile: '',
            phone: '',
            phone_ext: '',
            location_name: '',
            country: '',
            address: '',
            address2: '',
            city: '',
            zip: '',
            state: '',
            state_options: [
              { value: '', text: 'Select State' },
            ],
            market_area: '',
            remove_flag: false,
            last_login: '',
            no_login: '',
            is_mentee: 0,
            admin_courses: [],
            applicable_courses: [],
            admin_assessments: [],
            applicable_assessments: [],
            admin_status: this.getAdminStatus(),
            users_assigned_groups_count: 0,
            disableStatus: false,
          });
          this.getUserCourses();
          this.getUserAssessments();
        },
        getUserCourses() {
          var newUserId = this.admin_contacts.length - 1;
          var userType = this.admin_contacts[newUserId].user_type;
          this.mentor_courses = [];
          axios.get('/account-lookup/course-lists', {
            params: {
              user_roles: 'ROLE_MENTOR',
              account_id: this.accountId
            },
          })
          .then(response =>  {
            for(var i=0; i < response.data.length; i++) {
              var group = {value: response.data[i].value, name: response.data[i].name};
              this.mentor_courses.push(group);
            }
            this.admin_contacts[newUserId].applicable_courses = this.mentor_courses;

          })
          .catch(function(error) {
            console.log(error);
          });
        },
        getUserAssessments(){
          var newUserId = this.admin_contacts.length - 1;
          var userType = this.admin_contacts[newUserId].user_type;
          this.mentor_assessments = [];
          axios.get('/account-lookup/assessment-lists', {
            params: {
              user_roles: 'ROLE_MENTOR',
              account_id: this.accountId
            },
          })
          .then(response =>  {
            for(var i=0; i < response.data.length; i++) {
              var group = {value: response.data[i].value, name: response.data[i].name};
              this.mentor_assessments.push(group);
            }

            this.admin_contacts[newUserId].applicable_assessments = this.mentor_assessments;
          })
          .catch(function(error) {
            console.log(error);
          });
        },
        deleteAdminAction: function(index) {
          if(this.admin_contacts[index].uid == 0) {
            this.admin_contacts.splice(index, 1);
          }
          else {
            /* Soft Delete */
            axios('/user/' + this.admin_contacts[index].uid + '/' + this.accountId,
               {
                 method: 'DELETE',
               }
             )
            .then((resp) => {
                this.updated_admin_contacts = {};
                this.getAdminListData();
            })
            .catch(error => {

            });
          }
        },
        removeAdmin: function(index) {
          this.remove_data = this.admin_contacts[index];
          if((this.remove_data.is_primaryadmin != 1) && (this.remove_data.is_billingadmin != 1) && ((this.remove_data.is_mentee != 1)) && (this.remove_data.users_assigned_groups_count == 0) ) {
            this.isDeleteModalVisible = true;
            this.delete_id = index;
          }
          else {
            if((this.remove_data.is_primaryadmin == 1) || (this.remove_data.is_billingadmin == 1)) {
              this.validationMessage = "You cannot delete a billing or primary admin.";
            } else if (this.remove_data.users_assigned_groups_count > 0) {
              let pl_concat = (this.remove_data.users_assigned_groups_count > 1) ? "s" : "";
              let admin_type_name = (this.$parent.org_type == 'School') ? "instructor" : "mentor";
              let user_type_name = (this.$parent.org_type == 'School') ? "student" + pl_concat : "mentee" + pl_concat;
              let fullName = this.remove_data.admin_fname + "\n" + this.remove_data.admin_lname;
              var groupErrorMsg = "You cannot delete this " + admin_type_name +  " " + '"' + fullName + '"' + ".\nThis "+ admin_type_name +" is assigned to the below "+user_type_name+": \n";
              let i = 1; 
              this.remove_data.users_assigned_groups.forEach(function(item){
                groupErrorMsg += i + ". " + item.first_name + ' ' + item.last_name + "\n";
                i++;
              });
              this.validationMessage = groupErrorMsg;
            }

            this.isInfoModalVisible = true;
            return false;
          }
        },
        adminPhoneValid: function(event, index) {
          var phone_val = this.admin_contacts[index].phone;
          this.admin_contacts[index].phone = phone_val.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
        },
        adminMobileValid: function(event, index) {
          var phone_val = this.admin_contacts[index].mobile;
          this.admin_contacts[index].mobile = phone_val.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
        },
        adminPhoneExtValid: function(event, index) {
          var phone_val = this.admin_contacts[index].phone_ext;
          this.admin_contacts[index].phone_ext = phone_val.replace(/[^0-9]/g, '');
        },
        updateCountryUS: function(index) {
          this.updateAdminContactEvent(index, 'country', 'US');
          this.updateAdminContactEvent(index, 'state', '');
          this.admin_contacts[index].country = 'US';
          this.getStateLists(this.admin_contacts[index].country, index);
        },
        adminPhoneRegex: function() {
          return /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
        },
        adminPostalCodeRegex: function(index) {
          if (this.admin_contacts[index].country == "US") {
            return /^[0-9]{5}(?:-[0-9]{4})?$/;
          } else if (this.admin_contacts[index].country == "CA") {
            return /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;
          }
          return /./;
        },
        getCountryLists: function () {
          axios.get('/get-country-lists', {

          })
          .then(response =>  {
            this.country_options = response.data;
          })
          .catch(function(error) {

          });
        },
        getStateLists: function (CountryCode, index) {
          this.updateAdminContactEvent(index, 'state', '');
          this.admin_contacts[index].state = '';
          this.admin_contacts[index].state_options = [
            { value: '', text: 'Select State' },
          ];
          if(CountryCode == '') {
            CountryCode = null;
          }
          axios.get('/get-state-lists/' + CountryCode, {

          })
          .then(response =>  {
            this.admin_contacts[index].state_options = response.data;
          })
          .catch(function(error) {

          });
        },
        clickPrimaryAdmin: function(index) {
          for(var i=0; i < this.admin_contacts.length; i++) {
            this.updateAdminContactEvent(i, 'is_primaryadmin', false);
            this.admin_contacts[i].is_primaryadmin = 0;
          }
          this.updateAdminContactEvent(index, 'is_primaryadmin', true);
          this.admin_contacts[index].is_primaryadmin = 1;
        },
        clickBillingAdmin: function(index) {
          for(var i=0; i < this.admin_contacts.length; i++) {
            this.updateAdminContactEvent(i, 'is_billing', false);
            this.admin_contacts[i].is_billingadmin = 0;
          }
          this.updateAdminContactEvent(index, 'is_billing', true);
          this.admin_contacts[index].is_billingadmin = 1;
        },
        updateAdminContactEvent: function(index, field, value) {
          if(this.admin_contacts[index].uid > 0) {
            if(this.updated_admin_contacts[index]) {
              Vue.set(this.updated_admin_contacts[index], field, value);
            }
            else {
              this.updated_admin_contacts[index] = {};
              Vue.set(this.updated_admin_contacts[index], 'uid', this.admin_contacts[index].uid);
              Vue.set(this.updated_admin_contacts[index], field, value);
            }
            console.log(this.updated_admin_contacts[index]);
          }
        },
        getAdminListData: function() {
          if(this.$parent.org_type == 'Company') {
            this.mentor_label_name = 'Manager';
          }
          else {
            this.mentor_label_name = 'Instructor';
          }
          axios("/account_lookup_admin_list", {
            method: 'GET',
            params: {
              account_id: this.accountId,
            }
          })
          .then(response => {
            this.loading = false;
            this.admin_contacts = response.data;
            this.updated_admin_contacts = {};
          })
          .catch(error => {
            this.loading = false;
          });
        },
        addEvent ({ type, target }) {
          var regex1 = /\d+/g;
          var regex = /\[([0-9]+)\]/g;
          var name = target.name;
          var matches1 = name.match(regex);
          if(matches1) {
          var val = matches1[0];
          var matches = val.match(regex1);
          if(this.admin_contacts[matches].uid > 0) {
            var value;
            if((target.type == 'checkbox') || (target.type == 'radio')) {
              value = target.checked;
            }
            else {
              value = target.value;
            }
            var field = name.replace("["+matches+"]", "");
            this.updateAdminContactEvent(matches, field, value);

          }
          }
        },
        enterSearchAction: function(rowNo) {
          if (!rowNo)
            this.$parent.searchAction();
        },
        openContactModal: function(index) {
          this.isContactModalVisible = true;
          const vmessage = 'hide_vmessage';
          this.$refs.admin_contact_form.getAdminDetail(this.admin_contacts[index], vmessage);
        },
        openUserPreferenceModal: function(index) {
          this.isUserPreferenceModalVisible = true;
          this.$refs.user_preference.first_name = this.admin_contacts[index].admin_fname;
          this.$refs.user_preference.last_name = this.admin_contacts[index].admin_lname;
          this.$refs.user_preference.userId = this.admin_contacts[index].uid;
          this.$refs.user_preference.accountId = this.accountId;
          this.$refs.user_preference.getUserPreferenceDetails();
        },
        getCoursesInfo(index) {
          var userCourses =  this.admin_contacts[index].admin_courses;
          var courseIds = [];
          for(var i = 0; i < userCourses.length; i++) {
            courseIds.push(userCourses[i].value);
          }
          var userId = this.admin_contacts[index].uid;
          this.$refs['course_user_results_header_' + index][0].getCourses(userId, courseIds, this.accountId);
        },
        getAdminCourses(event, index) {
          if(this.researcher == false) {
          this.admin_contacts[index].applicable_courses = [];
          this.admin_contacts[index].admin_courses = [];
          var user_roles = 'ROLE_MENTOR';
          if (event.target.checked) {
            user_roles = 'ROLE_ADMIN,ROLE_MENTOR';
          }
          axios.get('/account-lookup/course-lists', {
            params: {
              user_roles: user_roles,
              account_id: this.accountId
            },
          })
          .then(response =>  {
            for(var i=0; i < response.data.length; i++) {
              var group = {value: response.data[i].value, name: response.data[i].name};
              this.admin_contacts[index].applicable_courses.push(group);
            }
          })
          .catch(function(error) {
            console.log(error);
          });
          }
        },
        getMentorCourses() {
          axios.get('/account-lookup/course-lists', {
            params: {
              user_roles: 'ROLE_MENTOR',
              account_id: this.accountId
            },
          })
          .then(response =>  {
            for(var i=0; i < response.data.length; i++) {
              var group = {value: response.data[i].value, name: response.data[i].name};
              this.mentor_courses.push(group);
            }
          })
          .catch(function(error) {
            console.log(error);
          });
        },
        getMentorAssessments() {
          axios.get('/account-lookup/assessment-lists', {
            params: {
              user_roles: 'ROLE_MENTOR',
              account_id: this.accountId
            },
          })
          .then(response =>  {
            for(var i=0; i < response.data.length; i++) {
              var group = {value: response.data[i].value, name: response.data[i].name};
              this.mentor_assessments.push(group);
            }
          })
          .catch(function(error) {
            console.log(error);
          });
        },
        captureMultiselectModificationAction(index, field, value) {
          this.updateAdminContactEvent(index, field, value);
        },
        getAdminStatus() {
          if (this.$parent.status == "" || this.$parent.status == "Prospect") {
            return "Prospect";
          } else if (this.$parent.status == "Active" || this.$parent.status == "Inactive") {
            return this.$parent.status;  
          } else {
            return '';
          }
        }
      },
      created: function () {
          var roles = this.$store.state.roles;
          if(roles.indexOf('ROLE_RESEARCHER') > -1) {
            this.researcher = true;
          }

        setTimeout(() => {
          this.admin_contacts.push({
            uid: 0,
            admin_fname: this.$store.getters.getSearchAccount.admin_fname ?  this.$store.getters.getSearchAccount.admin_fname : '',
            admin_lname: this.$store.getters.getSearchAccount.admin_lname ?  this.$store.getters.getSearchAccount.admin_lname : '',
            admin_email: this.$store.getters.getSearchAccount.admin_email ?  this.$store.getters.getSearchAccount.admin_email : '',
            admin_title: this.$store.getters.getSearchAccount.admin_title ?  this.$store.getters.getSearchAccount.admin_title : '',
            is_enabled: 0,
            is_transfer_status: 0,
            is_manager: 0,
            is_news: 1,
            is_billingadmin: 1,
            is_primaryadmin: 1,
            id_number: '',
            password: '',
            mobile: '',
            phone: '',
            phone_ext: '',
            location_name: '',
            country: '',
            address: '',
            address2: '',
            city: '',
            zip: '',
            state: '',
            state_options: [
              { value: '', text: 'Select State' },
            ],
            market_area: '',
            remove_flag: false,
            last_login: '',
            no_login: '',
            is_mentee: 0,
            admin_courses: [],
            applicable_courses: [],
            admin_assessments: [],
            applicable_assessments: [],
            admin_status: this.getAdminStatus(),
          });
          this.getCountryLists();
          if(this.accountId > 0) {
            this.loading = true;
            this.getAdminListData();
            this.getMentorCourses();
            this.getMentorAssessments();
          }
        }, 500);
      },
      mounted() {
        EventBus.$on('VeeValidate', () => {
          this.$validator.validateAll();
        });
      },
    }
</script>
<style scoped>
.prospect_email_heading_cls {
  width: 29%;
}
.prospect_admin_heading_12 {
  width: 16%;
}
.admin_heading_9 {
  width: 7%;
}
.admin_heading_11 {
  width: 7%;
}
.admin_heading_4 {
  width: 7%;
}
.admin_heading_6 {
  width: 9%;
}
.ma-input-field {
  line-height: 30px;
  margin-bottom: 5px;
  padding: 0 5px;
  color: #002F42;
  min-height: 38px;
}
.ma-blue-btn5, .ma-blue-btn5:focus, .ma-blue-btn5:active, .ma-blue-btn5:hover {
  color: #FFF !important;
  background: #00ACEE !important;
  border: 1px solid #00ACEE !important;
  min-height: 36px;
  margin-top: -5px;
}
.course-title{ 
  color: #002F42;
  font-weight: 900;
}
.course-title a {
  color: #707070;
  text-decoration: none;
}
.admin_heading_1 a {
  color: #707070;
  text-decoration: none;
}
</style>
<style>
#mentee-group-wrapper li span.multiselect__option--selected span::before {
  content: '\2713';
  color: #fff;
  background-color: #007bff;
  padding: 3px;
  margin-right: 5px;
}
#mentee-group-wrapper li span.multiselect__option--selected.multiselect__option--highlight {
  background-color: #fff !important;
  color: #212529 !important;
  font-weight: normal !important;
}
.multiselect__option--highlight {
  font-weight: normal !important;
  background-color: #fff !important;
  color: #212529 !important;
}
.multiselect__content-wrapper {
  min-width: 100%;
  width: auto !important;
  border-top: 1px solid #000 !important;
  border: 1px solid #000 !important;
}
.multiselect__option {
  font-size:13px;
}
.multiselect__option--selected {
  font-size: 13px;
  font-weight: normal !important;
}
.multiselect, .multiselect__input, .multiselect__single {
  font-size: 13px;
  font-weight: 400;
  color: #002F42;
  background-color: inherit !important;
}
.prospect_heading_5 {
  width: 9%;
}
.prospect_email_heading_cls {
  width: 24% !important;
}
.prospect_admin_heading_12 {
  width: 11% !important;
}
.pre-formatted { white-space: pre; padding: 0px; }
.goal-indicator-btn {
    border-radius: 10px;
    font-size: 13px;
    padding: 5px 15px;
    line-height: 12px;
    height: auto;
    width: 105px;
    text-align: center;
    outline: none !important;
}
.greenBtn, .greenBtn:active, .greenBtn:focus{
    color: #FFFFFF !important;
    background-color: #FF9900 !important;
    border: 1px solid #FF9900 !important;
    cursor: text;
}
.modal-header .sub-heading {
  color: #002F42;
}
.ma-blue-btn1 {
  color: #FFF !important; 
  background-color: #00acee !important;
  border: 1px solid #00acee !important;
  font-weight: 900;
  border-radius: 10px;
  width: 120px;
}
.ma-white-btn1 {
  color: #00ACEE !important; 
  background-color: #FFF !important;
  border: 1px solid #00ACEE !important;
  font-weight: 900;
  border-radius: 10px;
  width: 90px;
}

</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



// WEBPACK FOOTER //
// src/components/admin/account_lookup_admin_tab.vue